var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon32PxLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 11c-.624-.007-1.186.374-1.409.957-.223.582-.06 1.242.409 1.653V15c0 .552.448 1 1 1s1-.448 1-1v-1.39c.469-.411.632-1.07.409-1.653-.223-.583-.785-.964-1.409-.957zm5-4V5c0-2.761-2.239-5-5-5S3 2.239 3 5v2c-1.657 0-3 1.343-3 3v7c0 1.657 1.343 3 3 3h10c1.657 0 3-1.343 3-3v-7c0-1.657-1.343-3-3-3zM5 5c0-1.657 1.343-3 3-3s3 1.343 3 3v2H5V5zm9 12c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1v-7c0-.552.448-1 1-1h10c.552 0 1 .448 1 1v7z",
    transform: "translate(8 6)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon32PxLock);
export default __webpack_public_path__ + "static/media/4-icon-32-px-lock.38e14f9b.svg";
export { ForwardRef as ReactComponent };